<div class="user-management">
  @if (isLoading$ | async) {
    <div class="policy-spinner">
      <mat-progress-spinner class="loading-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else {
    <div class="user-management-tabs-section">
      <div class="tabs-titles">
        @if (tabs.length > 0) {
          <app-sidepanel-tabs [tabs]="tabs" (tabOnSelection)="onTabSelect($event)"></app-sidepanel-tabs>
        }
      </div>
      <div class="divider"></div>
    </div>

    <div class="scollable-tables">
      @if (currentTabIndex === 0) {
        <app-users></app-users>
      } @else {
        <app-account-apis></app-account-apis>
      }
    </div>
  }
</div>
